<div id="main-wrapper" class="show">
  <app-header *ngIf="!authService.getUserData()?.activeModule"></app-header>
  <app-header-secondary *ngIf="authService.getUserData()?.activeModule"></app-header-secondary>
  <app-sidebar *ngIf="!authService.getUserData()?.activeModule"></app-sidebar>

  <div [class]="!authService.getUserData()?.activeModule?'content-body':'m-3 mt-5 pt-3'">
    <app-breadcrumb></app-breadcrumb>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
